






















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import PositionDto from '@/models/Positions/PositionDto';
import ShiftViewModel from '@/models/Shifts/ShiftViewModel';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel';
import BreakDto from '@/models/Shared/BreakDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BookingDateDto from '@/models/BookingDates/BookingDateDto';
import BookingDateViewModel from '@/models/BookingDates/BookingDateViewModel';
import DateTimeUtils from '@/lib/dateTimeUtils';
import RateCardPositionDto from '@/models/RateCardPositions/RateCardPositionDto';

@Component({
    name: 'BookingDetailsBookingRoleCreate'
})
export default class extends GiganautVueDialog {
 
    dialog = false;
    bookingRole: BookingRoleViewModel = new BookingRoleViewModel();
    selectedDates: BookingDateViewModel[] = [];
  

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.bookingRole = new BookingRoleViewModel();
            await BookingDetailsModule.getNewBookingOptions();
        }
    }

    get positions() {
        return BookingDetailsModule.currentBooking.location.rateCard.positions;
    }

    get dates() {
        return BookingDetailsModule.currentBooking.dates.map(function(bookingDate) {
            const vm: BookingDateViewModel = new BookingDateViewModel();
            vm.bookingDate = bookingDate;
            vm.dateAsString = DateTimeUtils.toDDMMYY(bookingDate.date);
            return vm;
        });
    }

    get agencyUsers() {
      return BookingDetailsModule.newBookingOptions.agencyUsers;
    }

    get contactLocations() {
        return BookingDetailsModule.currentBooking.location.contactLocations;
    }

    get desks() {
        return BookingDetailsModule.currentBooking.branch.desks;
    }

    get skills() {
        return this.bookingRole.rateCardPosition.position.skills;
    }

    get qualifications() {
        return this.bookingRole.rateCardPosition.position.qualifications;
    }

    get uniforms() {
        return this.bookingRole.rateCardPosition.position.uniforms;
    }

    get selectedPosition() {
        return this.bookingRole.rateCardPosition;
    }
    set selectedPosition(rateCardPosition: RateCardPositionDto) {
        this.bookingRole.rateCardPosition = rateCardPosition;
        //Reset the form based on the selection of the position
        this.bookingRole.skills = [];
        this.bookingRole.qualifications = [];
        this.bookingRole.uniform = null;
        this.bookingRole.uniformDescription = null;
        this.bookingRole.positionDescription = rateCardPosition.position.description;
        this.bookingRole.chargeRate = rateCardPosition.chargeRate
        //TODO:DESK
        //this.bookingRole.desk = rateCardPosition.position.desk;
    }

    get selectedUniform() {
        return this.bookingRole.uniform;
    }
    set selectedUniform(value) {
        this.bookingRole.uniform = value;
        this.bookingRole.uniformDescription = value.description;
    }

    get loading() {
    return BookingDetailsModule.loadingDialog;
    }

    save() {
    if (!(this.$refs.form as any).validate()) {
        return;
    }
    //loop through the dates and create a shift
    for (let i = 0; i < this.selectedDates.length; i++) {
        const date = this.selectedDates[i].bookingDate.date
        const dateString = DateTimeUtils.toYYMMDD(date);
        const shift = new ShiftViewModel();
        shift.startAtDate = dateString;
        shift.startAtTime = this.bookingRole.startAtTime;
        shift.endAtTime = this.bookingRole.endAtTime;
        shift.quantity = this.bookingRole.quantity;
        shift.break = 20;
        this.bookingRole.shifts.push(shift);
    }
    BookingDetailsModule.createBookingRole(this.bookingRole);
    this.dialog = false;
    }
}
